import { React, useContext, useEffect, useState } from 'react'
import { AppContext } from "./../context/AppContext";
import ApiConfig from '../api/ApiConfig';
import { simpleGetCall, simplePostCall } from '../api/ApiServices';
import swal from 'sweetalert';

const PrivacyPolicy = () => {
  const { sidebar } = useContext(AppContext);

  const [privacyTxt, setPrivacyTxt] = useState({});

  useEffect(() => {
    fetchPrivacy();
  }, [])

  const fetchPrivacy = () => {
    simpleGetCall(ApiConfig.GET_PRIVACY_POLICY)
      .then((data) => {
        setPrivacyTxt(data.commonText);
        // setLoading(false);
        console.log("Privacy Data", data.commonText);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const updatePrivacy = (e) => {
    e.preventDefault();
    let reqBody = JSON.stringify({
      commanTextReq: privacyTxt
    })

    simplePostCall(ApiConfig.UPDATE_PRIVACY_POLICY, reqBody)
      .then((res) => {
        console.log("FInal Data", res);
        swal({
          text: res.message,
          icon: "success",
          timer: 2000,
          dangerMode: false,
          button: false
        });
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });
  }

  return (
    <main id="cx-main" className={sidebar ? "privacy-main" : "privacy-main cx-active"}>
      <div className="innerContent">
        <div className="heading-common mb-3">
          <label>PRIVACY POLICY</label>
        </div>
        <div className="cx-card-round">
          <div className="form-group">
            <label>Privacy Policy Content</label>
            <textarea
              className="form-control"
              placeholder="Please write Privacy Policy"
              id="floatingTextarea2"
              style={{ height: "250px" }}
              value={privacyTxt}
              onChange={(e) => { setPrivacyTxt(e.target.value) }}
            ></textarea>
            <div className="text-end">
              <button className="aboutUsSaveBtn" onClick={updatePrivacy}>Save</button>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default PrivacyPolicy